import { GooglePurchase } from "../GoogleSubscription";

export class MockGooglePurchase implements GooglePurchase {
  private static INDEX = 0;

  public orderId: string;
  public packageName = "packageName";
  public productId = "productId";
  public purchaseTime = new Date().getTime();
  public purchaseState = new Date().getTime();
  public purchaseToken = "purchaseToken";
  public autoRenewing = true;

  constructor() {
    MockGooglePurchase.INDEX++;
    this.orderId = `${MockGooglePurchase.INDEX}`;
  }
}
